import {AppBar, Container, Grid} from '@mui/material'
import React from 'react'
import {Outlet} from 'react-router-dom'
import Header from '../header/Header'
import WbButton from '../../common/WbButton'
import WbSecondaryButton from '../../common/WbSecondaryButton'
import paths from '../../../routes/paths'
import Stack from '@mui/material/Stack'
import {useNavigate} from 'react-router-dom'

export default function SafeSpaceCheckinPanel() {
  const navigate = useNavigate()
  return (
    <>
      <AppBar className="header">
        <Container maxWidth="xxl">
          <Header />
        </Container>
      </AppBar>
      <Container maxWidth="xxl" disableGutters>
        <div className="main-container">
          <Container maxWidth="lg" disableGutters>
            <Grid item lg={12} md={12} sm={12} xs={12} my={2}>
              <h2>Student Check-In</h2>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12} mb={2}>
              <Outlet />
            </Grid>
          </Container>
        </div>
      </Container>
    </>
  )
}
